<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00032">CHAPTER III</h2>
<h3 class="calibre8 sigil_not_in_toc" id="pgepubid00033">MAKING PLANS</h3>
<p class="calibre3">"I can't seem to get used to it," sighed Mollie several days later, as
she ran up the steps of her porch and opened the screen door for the
girls. "To think that no matter how much we want to go back to the
Hostess House—"</p>
<p class="calibre3">"There is no Hostess House to go back to," finished Grace, sinking down
in a luxurious porch swing and plumping the cushion behind her back.
Grace always had a gift for finding the soft places. "It is rather
discouraging."</p>
<p class="calibre3">"Just as we were going to work hard and forget how unhappy we were,
too," added Amy plaintively.</p>
<p class="calibre3">"Goodness, but we're not going to be unhappy," put in Betty, rocking
vigorously. "I thought we decided that three days ago."</p>
<p class="calibre3">"I know. But when we think—"</p>
<p class="calibre3">"But we musn't think," Betty interrupted quickly, adding with a little
twinkle: "About being unhappy, that is. All we have to do is just hold
on to the belief that the boys are coming<span id="pgepubid00034" title="[18]"><a id="Page_18" title="[18]"></a></span> back a year from now, maybe
less—coming back without a hair less than they had when they went
away."</p>
<p class="calibre3">"We didn't count 'em," said Mollie drolly. "The hairs, that is, so how
can we tell?"</p>
<p class="calibre3">"Isn't she funny?" drawled Grace, catching the pillow Mollie threw at
her and depositing it calmly behind her back. "Thanks, old dear," she
said. "I just needed another one."</p>
<p class="calibre3">"I thought we came to talk over the plans for our vacation," Amy put in
mildly, adding with a little laugh: "We have to take one now whether we
want it or not."</p>
<p class="calibre3">"But we haven't the slightest idea what we're going to do," protested
Grace. "I guess we'd just better stay at home and do nothing."</p>
<p class="calibre3">"My, aren't you encouraging?" cried Mollie, looking up indignantly from
the pair of socks she was knitting. "You might at least suggest
something."</p>
<p class="calibre3">"Ooh, there you are!"</p>
<p class="calibre3">They turned suddenly to see a mischievous little face peeping at them
from around the corner of the porch.</p>
<p class="calibre3">"Dodo, you little wretch, come here," cried Mollie, trying to look
severe and failing utterly.</p>
<p class="calibre3">"Now what mischief have you been up to?"</p>
<p class="calibre3">"No," protested Dodo, shaking her curly head<span id="pgepubid00035" title="[19]"><a id="Page_19" title="[19]"></a></span> vigorously, as she
reluctantly abandoned her vantage point and came slowly toward Mollie.
"No mischief 'tall. Me an' Paul jus' playin'."</p>
<p class="calibre3">This was Dora, nicknamed Dodo, and Paul, Mollie Billette's small brother
and sister, who were nearly always getting into some sort of mischief
from the time they stepped their little feet out of bed in the morning
till the time they slipped the same little feet, tired out with getting
into trouble, into bed at night.</p>
<p class="calibre3">"You darling!" cried Betty, catching the little figure to her and
administering a bear's hug. "You're terribly bad, but we can't help
loving you."</p>
<p class="calibre3">"Uh-uh," denied Dodo, wriggling free of Betty's embrace and looking at
her earnestly. "Me's never bad—only Paul."</p>
<p class="calibre3">"Ooh, Dodo Billette!" cried Paul, bursting in upon them from no one
could quite tell where. "You's a big story teller!"</p>
<p class="calibre3">"You's the big 'tory teller," cried Dodo, coming sturdily to the rescue
of her reputation. "You just go 'way. Mol—lie, oh, Mollie, make him go
'way!"</p>
<p class="calibre3">"Oh, dear!" cried Mollie, half amused and half vexed as she put aside
her knitting and took Dodo on her lap. "I thought you and Paul promised
to play with the bunnies all the after<span id="pgepubid00036" title="[20]"><a id="Page_20" title="[20]"></a></span>noon and not bother sister. Can't
you see she has company?"</p>
<p class="calibre3">"Yes," smiled the little girl, reaching up to pat Mollie's cheek
ingratiatingly. "Me an' Paul got tired playin' wiv bunnies an' came to
see you. We want," she added succinctly, "tandies!"</p>
<p class="calibre3">"Well, you won't get any, not this time," said Mollie definitely, trying
not to smile, while the other girls were not even trying. It was always
hard not to laugh at the twins, naughty as they often were.</p>
<p class="calibre3">"Why?" demanded Dodo severely.</p>
<p class="calibre3">"Never mind why," returned Mollie, putting the little girl down and
taking up her knitting again. "Now run off, both of you, we want to
talk."</p>
<p class="calibre3">"But we want tandies," repeated Dodo, looking surprised that Mollie had
not understood the first time. "Dive Paul an' me tandies—lots of
tandies—an' we'll go 'long. Shan't we, Paul? Ooh—" the question ended
in an anguished wail as Dora's eyes rested on her faithless twin.</p>
<p class="calibre3">The latter had extracted Grace's half-filled candy box from under a
cushion where she had hastily hidden it at the first threat of invasion
by the insatiable twins and was at the moment busily engaged in
devouring its contents. Grace had been too busy watching Dodo to notice
him.<span id="pgepubid00037" title="[21]"><a id="Page_21" title="[21]"></a></span></p>
<p class="calibre3">"Ooh, you bad boy! You bad boy!" wailed the little girl, making a dash
for Paul, who deftly evaded her and took refuge behind Betty's chair,
"Div me dos tandies—dive 'em to me."</p>
<p class="calibre3">"Can't," mumbled Paul, his mouth full, adding by way of explanation a
convincing: "All gone."</p>
<p class="calibre3">"Paul Billette, come here this minute," commanded Mollie sternly, while
Betty and Amy tried hard to check their rising mirth and Grace looked
bereft. "Come here I say."</p>
<p class="calibre3">"Make Dodo go 'way then," bargained Paul, adding in an explanatory tone:
"Last time she pulled my hair."</p>
<p class="calibre3">"An' me's goin' do it 'dain," declared Dodo vengefully, when Betty
reached over suddenly and pulled the little girl into her lap.</p>
<p class="calibre3">"Stay here a minute, Honey," she coaxed, and as Dodo tried vainly to
wriggle loose added: "Sister wants to speak to Paul."</p>
<p class="calibre3">"An' I," said Dodo soberly, "want to pull his hair."</p>
<p class="calibre3">Again the girls had to strangle their mirth while Mollie reiterated her
command to Paul. The latter, after regarding the wriggling Dodo for a
minute uncertainly, <ins class="calibre19" title="Transcriber's Note: original reads 'relucantly'">reluctantly</ins> left his refuge and stood before Mollie,
head hanging.</p>
<p class="calibre3">"I'se sorry," he said in a small voice, trying to<span id="pgepubid00038" title="[22]"><a id="Page_22" title="[22]"></a></span> forestall the
scolding he knew was coming. "Me never do it any more!"</p>
<p class="calibre3">"That," said Mollie sternly, though the corners of her mouth twitched
and there was a twinkle in her eye, "is just exactly what you say every
time you're a bad naughty boy. Now, just to make you remember how
naughty you were, you shan't have another piece of candy for a whole
week."</p>
<p class="calibre3">Paul's protest was drowned in a wail from Dora.</p>
<p class="calibre3">"But me wants some tandies," she cried. "Me didn't take any."</p>
<p class="calibre3">"She would, if Paul hadn't seem them first," murmured Grace, but Mollie
shot her a warning glance.</p>
<p class="calibre3">"No," she said, "and just for being such a good girl, sister's going to
give you six big chocolates all for yourself."</p>
<p class="calibre3">Dodo gave a shout of glee and disengaging herself with one last frantic
wriggle from Betty's embrace, precipitated herself upon Mollie like a
young cyclone.</p>
<p class="calibre3">"Ooh dive 'em to me, dive 'em to me quick," she demanded, then as Mollie
made good her promise the little girl turned upon the erring Paul a look
of conscious virtue and said gravely; "If you were a dood boy I would
div you one,<span id="pgepubid00039" title="[23]"><a id="Page_23" title="[23]"></a></span> but now me's goin' eat 'em up, every one till dey's all
gone."</p>
<p class="calibre3">Then she took to her heels, scurrying down the steps and around the
corner of the house with Paul in hot pursuit.</p>
<p class="calibre3">"Dodo," they heard him crying plaintively, "I'll let you play wiv my
best bunny if you will div me one candy, just one—"</p>
<p class="calibre3">"I wouldn't give much for his chances," chuckled Mollie, adding with a
sigh that was a mixture of exasperation and amusement. "Aren't they
perfectly terrible? There isn't a minute of the day when they're not in
some mischief."</p>
<p class="calibre3">"No, they're adorable," cried Betty fondly. "I wouldn't give two cents
for children that didn't get into mischief all the time."</p>
<p class="calibre3">"I don't care so much about the mischief," said Grace, eyeing her empty
chocolate box ruefully, "if they would only leave my candies alone."</p>
<p class="calibre3">"Never mind, Gracie," replied Mollie, laughing at her, "you shall have a
whole box of mine, so you shall."</p>
<p class="calibre3">"Fine," agreed Grace, adding with a chuckle as Mollie handed over the
almost full box: "Since my candies were more than half gone, I don't
call it such a bad bargain at that."</p>
<p class="calibre3">"I'll say it wasn't," dimpled Betty.</p>
<p class="calibre3">"Just the same," said Mollie, after a little pause,<span id="pgepubid00040" title="[24]"><a id="Page_24" title="[24]"></a></span> "even though the
twins are a great deal of trouble, Mother said she just wouldn't have
known what to do without them—especially after I went to Camp
Liberty—the house would have been so frightfully dull."</p>
<p class="calibre3">"I should think so," said Grace, adding suddenly, as though she had
thought of it for the first time: "Why she would have been all alone,
wouldn't she? How awful!" For Mollie had no father, he having died
several years before.</p>
<p class="calibre3">"And the other day she said the strangest thing," Mollie continued,
suddenly earnest. "You know how she adores Paul. Well, I caught her
looking at him with the most wistful expression, and when I asked her
what the matter was she looked up at me and I saw there were tears in
her eyes.</p>
<p class="calibre3">"'It's Paul,' she said softly. 'Of course I'm thankful he is so little
that I can keep him safe at home with me, but sometimes when I think of
my dear country and the terrible wrongs she has suffered, I almost wish
that my little son were old enough to bring retribution upon those
hideous Germans. Sometimes I feel cheated—yes, you needn't stare—that
I have not a son "over there".'"</p>
<p class="calibre3">"Oh, Mollie!" cried the Little Captain softly, "what a wonderful thing
to say. And yet I think<span id="pgepubid00041" title="[25]"><a id="Page_25" title="[25]"></a></span> she would die if anything happened to either of
the twins."</p>
<p class="calibre3">"That's just it," said Mollie, her eyes glowing with pride. "Loving them
as she does, she almost wishes it were possible to make the supreme
sacrifice for her country."</p>
<p class="calibre3">"It was that spirit," said Grace thoughtfully, "that won the battle of
the Marne."</p>
<p class="calibre3">For a long time after that the girls worked quietly, each busy with her
own thoughts. It was Amy who finally broke the silence.</p>
<p class="calibre3">"And here we are," she said plaintively, "letting another whole
afternoon slip by without deciding what we are going to do on our
vacation. Can't somebody suggest something?"</p>
<p class="calibre3">"I have already suggested half a dozen things, only to be laughed to
scorn," said Mollie, adding decidedly: "I'm through."</p>
<p class="calibre3">"And nothing I can say seems to meet with approval," added Betty
plaintively.</p>
<p class="calibre3">"Well," said Grace, stretching herself, sitting up in the swing, and
looking important, "nobody asks me whether I have anything to suggest,"
adding as they turned a battery of surprised and eager glances her way:
"I don't know whether I can be persuaded to tell you now or not."</p>
<p class="calibre3">"Tell us!" they cried, piling into the swing till the supporting ropes
creaked with the strain.<span id="pgepubid00042" title="[26]"><a id="Page_26" title="[26]"></a></span></p>
<p class="calibre3">"Can't we bribe you with candy?" pleaded Amy.</p>
<p class="calibre3">"No. I just made an advantageous trade in that article, you will
remember," was the answer.</p>
<p class="calibre3">"Anyway, we don't bribe, we command," put in Betty. "Grace, we refuse to
be trifled with. What have you to suggest? Out with it!"</p>
<p class="calibre3">"You'd better hurry," added Mollie, raising her knitting needle
threateningly, "before I spit thee like a pig!"<span id="pgepubid00043" title="[27]"><a id="Page_27" title="[27]"></a></span></p>
<div class="pg-boilerplate" id="calibre_pb_14"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?79e1013c